import { YardSpotConfigurationModel } from '../../models';
import { MatDialogRef } from '@angular/material/dialog';
import { ConfirmationDialogAfterClosedModel } from '../../../../../../ui-kit';

export class YardSpotListLoad {
  public static readonly type = '[YardSpotList] Load Yard Spot List';
}

export class YardSpotSave {
  public static readonly type = '[YardSpotList] Save Yard Spot Item';

  constructor(
    public payload: {
      data: YardSpotConfigurationModel;
      dialog: MatDialogRef<unknown>;
    },
  ) {}
}

export class YardSpotDelete {
  public static readonly type = '[YardSpotList] Delete Yard Spot Item';

  constructor(
    public payload: {
      dialog: MatDialogRef<ConfirmationDialogAfterClosedModel>;
      id: number;
    },
  ) {}
}

export class YardSpotListInitialState {
  public static readonly type = '[YardSpotList] Set Initial State';
}
